export const commissionCopy = {
  approve: 'Mark as reviewed',
  approveAll: 'Mark all as reviewed',
  finalApprove: 'Give final approval',
  unapproved: 'Awaiting review',
  approved: 'Awaiting final approval',
  paid: 'Approved',
  totalCommission: 'Total commission',
  reviewedCommission: 'Reviewed commission',
  approvedCommission: 'Approved commission',
  reopen: 'Reopen',
  responsibility: 'My responsibility',
  setupRequired: 'Commissions is not ready in this environment yet. Please contact your administrator.',
  accessFailed: 'Could not verify your access to Commissions. Please try again.',
  accessDenied: 'You do not have access to Commissions in this company.',
};
